"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createAndInstallPixels = exports.uninstallPixel = exports.fetchPixels = void 0;

var _reduxObservable = require("redux-observable");

var _q = _interopRequireDefault(require("q"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var _Pixel = _interopRequireDefault(require("./Pixel"));

var _usageTracker = _interopRequireDefault(require("settings-ui-sdk/utils/usageTracker"));

var fetchPixels = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getPixels,
  initiatingActionType: _actions.AdsPixelActionTypes.FETCH_PIXELS,
  requestStatusSelector: _selectors.getFetchPixelsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchPixels
}));
exports.fetchPixels = fetchPixels;
var uninstallPixel = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.uninstallPixel,
  initiatingActionType: _actions.AdsPixelActionTypes.UNINSTALL_PIXEL,
  requestStatusSelector: _selectors.getUninstallPixelRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.UninstallPixel
}));
exports.uninstallPixel = uninstallPixel;
var createAndInstallPixels = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: function apiFunction(pixels) {
    var pixelsToCreate = pixels.filter(function (pixel) {
      return !pixel.id;
    });
    var existingPixels = pixels.filter(function (pixel) {
      return !!pixel.id;
    });
    var promises = pixelsToCreate.toArray().map(function (pixel) {
      return _API.default.createPixel(pixel).then(function (response) {
        _usageTracker.default.track('modifyPixel', {
          action: 'Create pixel',
          network: pixel.adNetwork
        });

        return response;
      }).then(_Pixel.default).then(_API.default.installPixel).then(function (response) {
        _usageTracker.default.track('modifyPixel', {
          action: 'Install pixel',
          network: pixel.adNetwork
        });

        return response;
      });
    });
    promises = promises.concat(existingPixels.toArray().map(function (pixel) {
      return _API.default.installPixel(pixel).then(function (response) {
        _usageTracker.default.track('modifyPixel', {
          action: 'Install pixel',
          network: pixel.adNetwork
        });

        return response;
      });
    }));
    return _q.default.Promise.all(promises);
  },
  initiatingActionType: _actions.AdsPixelActionTypes.CREATE_AND_INSTALL_PIXELS,
  requestStatusSelector: _selectors.getCreateAndInstallPixelsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.PENDING, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.CreateAndInstallPixels
}));
exports.createAndInstallPixels = createAndInstallPixels;

var _default = (0, _reduxObservable.combineEpics)(createAndInstallPixels, fetchPixels, uninstallPixel);

exports.default = _default;